import { BEST_MATCHES_SORT_ID } from '@/lib/plp-panel-url-state';

/** Newest first. Applied when a news listing URL has no `sort` param. */
export const NEWS_LISTING_DEFAULT_SORT_ID = 'creationDate=desc';

/** Maps SCAPI content sort ids (e.g. `name=asc`) to i18n keys under `categoryPlp:contentSortOptions`. */
export function contentSortIdToTranslationKey(sortId: string): string {
    const [attribute, direction] = sortId.split('=');
    if (!attribute || !direction) {
        return sortId;
    }

    const directionSuffix = direction === 'asc' ? 'Asc' : 'Desc';
    return `${attribute}${directionSuffix}`;
}

export function resolveContentSearchSort(
    sortFromUrl: string,
    configuredOptions?: Array<{ id: string }>,
    defaultSortId?: string
): string {
    const configuredIds = configuredOptions?.map((option) => option.id) ?? [];

    if (configuredIds.length === 0) {
        return sortFromUrl;
    }

    // Explicit relevance omits `c_sort` even when a listing default would otherwise apply.
    if (sortFromUrl === BEST_MATCHES_SORT_ID) {
        return '';
    }

    if (sortFromUrl && configuredIds.includes(sortFromUrl)) {
        return sortFromUrl;
    }

    if (!sortFromUrl && defaultSortId && configuredIds.includes(defaultSortId)) {
        return defaultSortId;
    }

    return '';
}
